export default __webpack_public_path__ + "static/12-cctv-camera-6e0b7e2e07148a803733a7fada3e52bf.png";